import React, { useState, useEffect, useRef, act } from 'react'
import Api from '../../../../_helpers/Api'
import { useParams, useHistory } from 'react-router-dom'
import { useAuthDataContext } from '../../../../_providers/Auth'
import { trans } from '../../../../_providers/Translation'

//images
import loader from '../../../../assets/img/loader.svg'
import { Tab, Tabs } from '@mui/material'
import Pagination from '../../../Pagination'
import moment from 'moment'
import NoDataFound from '@/components/partials/NoDataFound'
import Skeleton from 'react-loading-skeleton'

function History(props) {
    const auth = useAuthDataContext()
    const params = useParams()

    const [state, setState] = useState({
        loading: true,
        data: null
    })

    //NEW: За добавяне на нови подтабове
    const [activeTab, setActiveTab] = useState('actions') // 'actions', 'repairs', 'activity'

    // Activity log state
    const [activityLog, setActivityLog] = useState({
        loading: false,
        data: [],
        limit: 20,
        page: 1,
        totalPages: 1,
    })

    // Repairs history
    const [repairsHistory, setRepairsHistory] = useState({
        loading: false,
        data: []
    })

    useEffect(() => {
        Api.get('reservations/history?id=' + params.id)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    data: res.data,
                    loading: false,
                }))
            })

        Api.get('reservations/repairs-history?id=' + params.id)
            .then(res => {
                setRepairsHistory(prev => ({
                    ...prev,
                    data: res.data,
                    loading: false,
                }))
            })
    }, [])

    // Load activity log — accepts explicit page to avoid stale state reads
    const loadActivityLog = (page = 1) => {
        setActivityLog(prev => ({ ...prev, loading: true, page }))

        Api.get(`reservations/activity-log?id=${params.id}&limit=${activityLog.limit}&page=${page}`)
            .then(res => {
                setActivityLog(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data?.items || [],
                    totalPages: res.data?.pages || 1,
                }))
            })
            .catch(() => {
                setActivityLog(prev => ({ ...prev, loading: false, data: [] }))
            })
    }

    // Load activity log when tab changes to activity
    useEffect(() => {
        if (activeTab === 'activity' && activityLog.data.length === 0) {
            loadActivityLog(1)
        }
    }, [activeTab])

    const renderTabContent = () => {
        switch (activeTab) {
            case 'actions':
                return renderActionsHistory()
            case 'repairs':
                return renderRepairsHistory()
            case 'activity':
                return renderActivityLog()
            default:
                return renderActionsHistory()
        }
    }

    const renderActionsHistory = () => (
        <>
            <div className="pannel">
                <h3>
                    {trans('random.creationDate')}
                </h3>
                <div className="table-scroller">
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    {trans('tables.createdBy')}
                                </th>
                                <th>
                                    {trans('tables.date')}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    {state.data.created_by
                                        ? `${state.data.created_by.name} ${state.data.created_by.lastname}`
                                        : '-'
                                    }
                                </td>
                                <td>
                                    {state.data.created_date}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="pannel">
                <h3>
                    SMS/Email
                </h3>
                {state.data.sentsmsmails.length === 0
                    ?
                    <div className="alert warning">
                        {trans('messages.noSavedInfo')}
                    </div>
                    :
                    <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        {trans('tables.to')}
                                    </th>
                                    <th>
                                        {trans('tables.topic')}
                                    </th>
                                    <th>
                                        {trans('tables.date')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.sentsmsmails.map(r =>
                                    <tr key={'ssm-' + r.id}>
                                        <td>
                                            {r.to}
                                        </td>
                                        <td>
                                            {r.subject}
                                        </td>
                                        <td>
                                            {r.date}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }
            </div>

            <div className="pannel">
                <h3>
                    {trans('random.sentInvoices')}
                </h3>
                {state.data.sentinvoices.length === 0
                    ?
                    <div className="alert warning">
                        {trans('messages.noSavedInfo')}
                    </div>
                    :
                    <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.to')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.topic')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.info')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.employee')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.date')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.sentinvoices.map(r =>
                                    <tr key={'si-' + r.id}>
                                        <td style={{ width: '20%' }}>
                                            {r.to}
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.subject}
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.url
                                                ?
                                                <a href={r.url} target="_blank">
                                                    {r.text}
                                                </a>
                                                :
                                                r.text
                                            }
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.employee
                                                ?
                                                `${r.employee.name} ${r.employee.lastname}`
                                                :
                                                '-'
                                            }
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.date}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }
            </div>

            <div className="pannel">
                <h3>
                    {trans('random.sentReports')}
                </h3>
                {state.data.sentreports.length === 0
                    ?
                    <div className="alert warning">
                        {trans('messages.noSavedInfo')}
                    </div>
                    :
                    <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.to')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.topic')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.info')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.employee')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.date')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.sentreports.map(r =>
                                    <tr key={'sr-' + r.id}>
                                        <td style={{ width: '20%' }}>
                                            {r.to}
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.subject}
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.url
                                                ?
                                                <a href={r.url} target="_blank">
                                                    {r.text}
                                                </a>
                                                :
                                                r.text
                                            }
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.employee
                                                ?
                                                `${r.employee.name} ${r.employee.lastname}`
                                                :
                                                '-'
                                            }
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.date}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }
            </div>

            <div className="pannel">
                <h3>
                    {trans('random.sentOffers')}
                </h3>
                {state.data.sentquotes.length === 0
                    ?
                    <div className="alert warning">
                        {trans('messages.noSavedInfo')}
                    </div>
                    :
                    <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.to')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.topic')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.info')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.employee')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.date')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.sentquotes.map(r =>
                                    <tr key={'sq-' + r.id}>
                                        <td style={{ width: '20%' }}>
                                            {r.to}
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.subject}
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.url
                                                ?
                                                <a href={r.url} target="_blank">
                                                    {r.text}
                                                </a>
                                                :
                                                r.text
                                            }
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.employee
                                                ?
                                                `${r.employee.name} ${r.employee.lastname}`
                                                :
                                                '-'
                                            }
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.date}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }
            </div>

            <div className="pannel">
                <h3>
                    {trans('random.employeeReport')}
                </h3>
                {state.data.reports.length === 0
                    ?
                    <div className="alert warning">
                        {trans('messages.noSavedInfo')}
                    </div>
                    :
                    <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        {trans('tables.date')}
                                    </th>
                                    <th>
                                        {trans('tables.report')}
                                    </th>
                                    <th>
                                        {trans('tables.employee')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.reports.map(r =>
                                    <tr key={'r-' + r.id}>
                                        <td>
                                            {r.date_dmy}
                                        </td>
                                        <td>
                                            {r.report}
                                        </td>
                                        <td>
                                            {r.employee
                                                ? `${r.employee.name} ${r.employee.lastname}`
                                                : '-'
                                            }
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }
            </div>

            <div className="pannel">
                <h3>
                    {trans('random.payments')}
                </h3>
                {state.data.payments.length === 0
                    ?
                    <div className="alert warning">
                        {trans('messages.noSavedInfo')}
                    </div>
                    :
                    <div className="table-scroller">
                        <table className="invoices">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>{trans('tables.type')}</th>
                                    <th>{trans('tables.price')}</th>
                                    <th>{trans('tables.documentNumber')}</th>
                                    <th>{trans('tables.date')}</th>
                                    <th>{trans('tables.paymentMethod')}</th>
                                    <th>{trans('tables.employee')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.payments.map(i =>
                                    <tr key={'i-' + i.id}>
                                        <td>{i.id}</td>
                                        <td>{i.type}</td>
                                        <td>{i.price_formatted} {i.currency && i.currency.name}</td>
                                        <td>
                                            {i.invoice
                                                ?
                                                <a href={i.invoice.full_url + '&token=' + auth.token()} target="_blank">
                                                    {i.invoice.number}
                                                </a>
                                                :
                                                '-'
                                            }
                                        </td>
                                        <td>{i.created_at_dmy}</td>
                                        <td>
                                            {i.paymentmethod
                                                ?
                                                i.paymentmethod.translation.name
                                                :
                                                ''
                                            }
                                        </td>
                                        <td>
                                            {i.employee
                                                ?
                                                `${i.employee.name} ${i.employee.lastname}`
                                                :
                                                '-'
                                            }
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </>
    )

    const renderRepairsHistory = () => (
        <>
            <div className="pannel">
                <h3>
                    {trans('headings.repairsHistory')}
                </h3>
                {repairsHistory.loading ?
                    <Skeleton height={45} count={10} />
                    : repairsHistory.data.length === 0 ?
                        <NoDataFound />
                        : <div className="table-scroller">
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            {trans('labels.id')}
                                        </th>
                                        <th>
                                            {trans('labels.serialNo')}
                                        </th>
                                        <th>
                                            {trans('tables.date')}
                                        </th>
                                        <th>
                                            {trans('tables.activity')}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {repairsHistory.data.map((r, index) =>
                                        <tr key={r.appliance_id}>
                                            <td>
                                                {r.appliance.id}
                                            </td>
                                            <td>
                                                {r.appliance.serial_no}
                                            </td>
                                            <td>
                                                {moment(r.appliance.created_at).format('DD MMM YYYY, HH:mm')}
                                            </td>
                                            <td>
                                                {r.reports?.[0]?.report || '-'}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                }
            </div>
        </>
    )

    const renderActivityLog = () => {
        // Flatten: each change becomes its own row
        const rows = []
        activityLog.data.forEach(activity => {
            const userName = activity.user_name || activity.user?.full_name || activity.user?.name || null

            const details = activity.changes?.details

            if (activity.action === 'created' || activity.is_created) {
                rows.push({
                    num: activity.id,
                    date: activity.date,
                    before: activity.action_translation || `Създадена нова резервация ${params.id}`,
                    after: '-',
                    userName,
                })
            } else if (details && details.length > 0) {
                details.forEach((change, ci) => {
                    rows.push({
                        num: activity.id,
                        date: activity.date,
                        before: change.from || '-',
                        after: change.to || '-',
                        userName,
                    })
                })
            } else {
                rows.push({
                    num: activity.id,
                    date: activity.date,
                    before: activity.action_translation || activity.action,
                    after: '-',
                    userName,
                })
            }
        })

        return (
            <>
                <div className="pannel">
                    <h3>Activity Log</h3>
                    {activityLog.loading ? (
                        <Skeleton height={45} count={10} />
                    ) : rows.length === 0 ? (
                        <NoDataFound />
                    ) : (
                        <div className="table-scroller">
                            <table>
                                <thead>
                                    <tr>
                                        <th>№</th>
                                        <th>{trans('tables.date')}</th>
                                        <th>Преди</th>
                                        <th>След</th>
                                        <th style={{ position: 'sticky', right: 0, background: '#fff', zIndex: 1 }}>Потребител</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((row, index) => (
                                        <tr key={index}>
                                            <td>{row.num}</td>
                                            <td style={{ whiteSpace: 'nowrap' }}>{row.date}</td>
                                            <td style={{ maxWidth: 300, wordBreak: 'break-word' }}>{row.before}</td>
                                            <td style={{ maxWidth: 300, wordBreak: 'break-word' }}>{row.after}</td>
                                            <td style={{ position: 'sticky', right: 0, background: '#fff', whiteSpace: 'nowrap', boxShadow: '-2px 0 4px rgba(0,0,0,0.06)' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <span style={{
                                                        width: 28, height: 28, borderRadius: '50%',
                                                        background: '#e0784e', color: '#fff',
                                                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                                        fontSize: 12, fontWeight: 600, flexShrink: 0
                                                    }}>
                                                        {row.userName ? row.userName.charAt(0).toUpperCase() : '?'}
                                                    </span>
                                                    {row.userName || '-'}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    <Pagination
                        pages={activityLog.totalPages}
                        page={activityLog.page}
                        handlePage={p => loadActivityLog(p.selected + 1)}
                    />
                </div>
            </>
        )
    }

    return (
        <div id="reservation-history">
            <div className='pannel'>
                {state.loading ?
                    <img src={loader} alt="loading" />
                    :
                    <>
                        <Tabs value={activeTab} onChange={(e, val) => setActiveTab(val)}>
                            <Tab label="История на действията" value="actions" />
                            <Tab label="История на ремонтите" value="repairs" />
                            <Tab label="Activity Log" value="activity" />
                        </Tabs>

                        {/* Tab content */}
                        <div className="tab-content">
                            {renderTabContent()}
                        </div>
                    </>}
            </div>
        </div>
    )
}

export default History